import Vue from 'vue';

Vue.directive('tooltip', {
  bind (el, { value, modifiers }, vnode) {
    const options = [];
    let placement = 'top';
    let trigger = 'hover';

    for (const key in modifiers) {
      if (Object.prototype.hasOwnProperty.call(modifiers, key)) {
        options.push(key);
      }
    }

    options.forEach(option => {
      if (['top', 'right', 'left', 'bottom'].includes(option)) {
        placement = option;
      } else if (['hover', 'focus', 'click'].includes(option)) {
        trigger = option;
      }
    });

    if (trigger === 'focus') {
      vnode.clickHandler = () => el.focus();
      el.addEventListener('click', vnode.clickHandler);
    }

    $(el).tooltip({
      title: value,
      placement,
      trigger,
      container: 'body',
    });
  },

  update (el, { value }) {
    $(el).attr('title', value).tooltip('fixTitle');
  },

  unbind (el, binding, { clickHandler }) {
    if (clickHandler) {
      el.removeEventListener('click', clickHandler);
    }

    $(el).tooltip('destroy');
  },
});

Vue.directive('click-outside', {
  bind (el, binding, vnode) {
    vnode.clickOutside = {
      triggerEvent () {
        binding.value();
      },
      stopEvent (event) {
        event.stopPropagation();
      },
    };
    const self = vnode.clickOutside;
    el.addEventListener('click', self.stopEvent);
    document.body.addEventListener('click', self.triggerEvent);
  },
  update (el, binding, vnode, { clickOutside }) {
    vnode.clickOutside = clickOutside;
  },
  unbind (el, binding, { clickOutside }) {
    el.removeEventListener('click', clickOutside.stopEvent);
    document.body.removeEventListener('click', clickOutside.triggerEvent);
  },
});

Vue.directive('intl-tel-input', {
  inserted (el, { value }) {
    Functions.telephoneInput();
    el.intlTelInstance = intlTelInputGlobals.getInstance(el);
    const inputs = document.querySelectorAll('.phone');

    if (value) el.intlTelInstance.setNumber(value);

    if (inputs.length > 1) {
      el.setInputValue = () => {
        for (const input of inputs) {
          if (input !== el) {
            intlTelInputGlobals.getInstance(input).setNumber(el.value);
          }
        }
      };
      el.addEventListener('input', el.setInputValue);
    }
  },
  update ({ intlTelInstance }, { value, oldValue }) {
    if (!oldValue && value) intlTelInstance.setNumber(value);
  },
  unbind (el) {
    el.intlTelInstance.destroy();
    el.removeEventListener('input', el.setInputValue);
  },
});

Vue.directive('clipboard', {
  inserted (el) {
    el.clipboard = Functions.initClipboard(el);
  },
  unbind (el) {
    el.clipboard.destroy();
  },
});

Vue.filter('offersCount', ({ offers_count, book_now_offers }) => offers_count + Object.keys(book_now_offers).length);

Vue.directive('textarea-autosize', {
  bind (el) {
    autosize(el);
  },
  unbind (el) {
    autosize.destroy(el);
  },
});
